/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/network-1214307': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M10 14a1 1 0 00-1 1v6a1 1 0 002 0v-6a1 1 0 00-1-1zm-5 4a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zM20 2a1 1 0 00-1 1v18a1 1 0 002 0V3a1 1 0 00-1-1zm-5 7a1 1 0 00-1 1v11a1 1 0 002 0V10a1 1 0 00-1-1z"/>'
  }
})
